import { render } from "./Reviews.vue?vue&type=template&id=975846b4"
import script from "./Reviews.vue?vue&type=script&lang=ts"
export * from "./Reviews.vue?vue&type=script&lang=ts"
script.render = render

export default script